import { useResolvedTheme } from '@sohanscript/theme/store';
import * as React from 'react';

const FAVICON_SELECTOR = 'link[data-theme-favicon]';

export function ThemeFavicon() {
	const resolvedTheme = useResolvedTheme();

	React.useEffect(() => {
		const favicons =
			document.head.querySelectorAll<HTMLLinkElement>(FAVICON_SELECTOR);
		if (!favicons.length) return;
		if (
			[...favicons].every((favicon) => favicon.dataset.theme === resolvedTheme)
		)
			return;

		const primary = getComputedStyle(document.documentElement)
			.getPropertyValue('--primary')
			.trim();
		const background = getComputedStyle(document.documentElement)
			.getPropertyValue('--primary-foreground')
			.trim();
		if (!primary || !background) return;
		const systemIsDark = window.matchMedia(
			'(prefers-color-scheme: dark)',
		).matches;
		const appIsDark = document.documentElement.classList.contains('dark');
		const shouldAddBackground = appIsDark !== systemIsDark;

		const source = favicons[0].dataset.source ?? favicons[0].href;
		favicons.forEach((favicon) => {
			favicon.dataset.source = source;
		});

		void fetch(source)
			.then((response) => response.text())
			.then((svg) => {
				const backgroundRect = shouldAddBackground
					? `<rect width="249" height="249" rx="48" fill="${background}"/>`
					: '';
				const themedSvg = svg
					.replace(
						'width="195" height="249" viewBox="0 0 195 249"',
						'width="249" height="249" viewBox="0 0 249 249"',
					)
					.replace(
						/(<svg\b[^>]*>)/,
						`$1${backgroundRect}<g transform="translate(27 0)">`,
					)
					.replace('</svg>', '</g></svg>')
					.replaceAll('#6FCBFF', primary);
				const href = `data:image/svg+xml,${encodeURIComponent(themedSvg)}`;
				favicons.forEach((favicon) => {
					favicon.href = href;
					favicon.dataset.theme = resolvedTheme;
				});
			});
	}, [resolvedTheme]);

	return null;
}
